import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { OrderOpportunity } from 'modules/orders/types'

type Query = {
  opportunityId: string
}

const loadOrderCustomerByOpportunity = (
  data: Query
): Promise<OrderOpportunity> => {
  return axios.get(`/orders/opportunities/${data.opportunityId}`)
}

export function useLoadOrderCustomerByOpportunity(query: Query) {
  return useQuery(
    ['orderCustomerByOpportunity', query],
    () => loadOrderCustomerByOpportunity(query),
    {
      enabled: !!query.opportunityId,
      onError: () =>
        toast.error('Não foi possível carregar o cliente da oportunidade!', {
          toastId: 'orderCustomerByOpportunity'
        })
    }
  )
}
